import { CONTEXT_PATH } from './constant';

// Single source of truth for the reception module's absolute route paths,
// used both for <Link>/navigate() targets and for the sidebar menu.
export const RECEPTION_PATHS = {
    register: `/${CONTEXT_PATH}/reception/register`,
    checkIn: `/${CONTEXT_PATH}/reception/check-in`,
    payment: `/${CONTEXT_PATH}/reception/payment`,
    transactions: `/${CONTEXT_PATH}/reception/transactions`,
    report: `/${CONTEXT_PATH}/reception/report`,
    reports: `/${CONTEXT_PATH}/reception/reports`
};
